import React, { useState } from 'react';
import { useQuotations } from '../hooks/useQuotations';
import QuotationList from '../components/quotations/QuotationList';
import QuotationFormSimple from '../components/quotations/QuotationFormSimple';
import { CreateQuotationData } from '../types/quotation';
import Modal from '../components/common/Modal';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../contexts/LanguageContext';
import toast from 'react-hot-toast';

const Quotations: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { createQuotation } = useQuotations();
  const { t } = useLanguage();

  const handleCreateQuotation = async (data: CreateQuotationData) => {
    try {
      await createQuotation(data);
      setIsModalOpen(false);
      toast.success(t('common.messages.quotation.createSuccess'));
    } catch (error) {
      console.error('Error creating quotation:', error);
      toast.error(t('common.messages.quotation.createError'));
    }
  };

  return (
    <div className="space-y-4">
      <QuotationList onNewClick={() => setIsModalOpen(true)} />

      <QuotationFormSimple
        isOpen={isModalOpen}
        onSubmit={handleCreateQuotation}
        onCancel={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default Quotations; 